import * as _ from 'lodash';
import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../redux/issuesV2';
import Flex from '../../generic/Flex';

import IssueItemLoading from './IssueItem/IssueItemLoading';

/**
 * Renders the entire loading table, using the count
 * to determine the number of loading rows to render.
 */
const IssuesTableLoading: VoidFunctionComponent = () => {
  const count = useSelector(IssuesV2Store.selectors.getCount);
  const isComparisonModeOn = useSelector(IssuesV2Store.selectors.getComparisonMode);

  return (
    <div className="issues-table-body" data-test-id="issues-inbox-loading">
      <Flex direction="column" grow="1">
        {_.times(count, () => <IssueItemLoading shouldHideCheckbox={isComparisonModeOn} />)}
      </Flex>
    </div>
  );
};

export default IssuesTableLoading;
